
import StoryblokImage from './StoryblokImage.vue'

import { getVilleSlug } from '~/plugins/boutique'

export default {
  name: 'ProductBoutique',
  components: { StoryblokImage },
  props: {
    boutique: {
      type: Object,
      required: true
    }
  },
  computed: {
    firstImage() {
      return this.boutique.carousel[0].Images[0]
    }
  },
  methods: { getVilleSlug }
}
